'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-recipient-list', {
      url: '/mail/recipient/list',
      template: '<mail-recipient-list></mail-recipient-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/recipient/list/mail-recipient-list.routes.js